export default Object.freeze({
  NEUTRAL: 'neutral',
  DANGER: 'danger',
  INFO: 'info',
  SUCCESS: 'success',
  WARNING: 'warning',
});
